'use strict';

var DuplicateNameService = function DuplicateNameService() {
  var duplicatedNamePrefix = 'Copy of ';
  function validateName(name, names) {
    if (names.indexOf(name) !== -1) {
      return createNewName(name, names);
    } else {
      return name;
    }
  }
  function createNewName(name, names) {
    names = names || [];
    var newName;
    if (name.indexOf(duplicatedNamePrefix) === 0) {
      var indexRegExp = /(.+ \()(\d+)(\))$/;
      var match = name.match(indexRegExp);
      if (match && match.length) {
        var newIndex = parseFloat(match[2]) + 1;
        newName = name.replace(indexRegExp, '$1' + newIndex + '$3');
        return validateName(newName, names);
      } else {
        newName = name + ' (1)';
        return validateName(newName, names);
      }
    } else {
      newName = duplicatedNamePrefix + name;
      return validateName(newName, names);
    }
  }
  return {
    createNewName: createNewName
  };
};
DuplicateNameService.$inject = [];
module.exports = DuplicateNameService;